var render, staticRenderFns
import script from "./AppDrawer.vue?vue&type=script&lang=tsx"
export * from "./AppDrawer.vue?vue&type=script&lang=tsx"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=e27a22aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27a22aa",
  null
  
)

export default component.exports